import {
    INVALID_TYPE_FILENAME,
    INVALID_TYPE_SHEET,
    INVALID_TYPE_SHEET_DATA,
    INVALID_TYPE_SHEETS,
    MISSING_KEY_FILENAME
} from './commons/constants';

const childValidator = (array) =>
{
    return array.every(item => Array.isArray(item));
};

export default (config) =>
{
    if( !config.filename )
    {
        console.error(MISSING_KEY_FILENAME);
        return false;
    }

    if( typeof config.filename !== 'string' )
    {
        console.error(INVALID_TYPE_FILENAME);
        return false;
    }

    if( !Array.isArray(config.sheets) )
    {
        console.error(INVALID_TYPE_SHEETS);
        return false;
    }

    for( const sheet of config.sheets )
    {
        if( !Array.isArray(sheet.data) )
        {
            console.error(INVALID_TYPE_SHEET);
            return false;
        }

        if( !childValidator(sheet.data) )
        {
            console.error(INVALID_TYPE_SHEET_DATA);
            return false;
        }
    }

    return true;
};
